import React, { useEffect, useState } from "react";
import { auth } from "../firebase";

const API_BASE = "https://sellerproxy-898712575285.us-central1.run.app";

// ── tiny helpers ──────────────────────────────────────────────────────────────
function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      {label && (
        <label style={{ display: "block", fontSize: 12, fontWeight: 600,
          color: "#6b7280", marginBottom: 4, textTransform: "uppercase",
          letterSpacing: "0.05em" }}>
          {label}
        </label>
      )}
      {children}
    </div>
  );
}

const inputStyle = {
  width: "100%", padding: "10px 14px", borderRadius: 8,
  border: "1px solid #d1d5db", fontSize: 14, boxSizing: "border-box",
  outline: "none", background: "#fff",
};

const selectStyle = {
  ...inputStyle, appearance: "none",
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center",
  paddingRight: 36,
};

function CardSection({ title, accent = "#2563eb", children }) {
  return (
    <div style={{
      background: "#fff", border: `1px solid #e5e7eb`,
      borderTop: `3px solid ${accent}`,
      borderRadius: 10, padding: 16, marginBottom: 16,
    }}>
      <h3 style={{ margin: "0 0 14px", fontSize: 14, fontWeight: 700,
        color: "#111827", display: "flex", alignItems: "center", gap: 8 }}>
        {title}
      </h3>
      {children}
    </div>
  );
}

function Btn({ onClick, disabled, loading, children, variant = "primary", small }) {
  const base = {
    border: "none", borderRadius: 8, fontWeight: 700, cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1, fontSize: small ? 13 : 14,
    padding: small ? "8px 14px" : "11px 18px", transition: "opacity .15s",
  };
  const variants = {
    primary: { background: "linear-gradient(135deg,#2563eb,#7c3aed)", color: "#fff" },
    success: { background: "linear-gradient(135deg,#059669,#0284c7)", color: "#fff" },
    ghost:   { background: "#f3f4f6", color: "#374151" },
  };
  return (
    <button type="button" onClick={onClick} disabled={disabled} style={{ ...base, ...variants[variant] }}>
      {loading ? "Please wait…" : children}
    </button>
  );
}

function Toast({ message, type, onClose }) {
  if (!message) return null;
  return (
    <div style={{
      padding: "12px 16px", borderRadius: 8, marginBottom: 12, fontSize: 14,
      display: "flex", justifyContent: "space-between", alignItems: "center",
      background: type === "success" ? "#dcfce7" : "#fee2e2",
      color: type === "success" ? "#166534" : "#991b1b",
    }}>
      <span>{message}</span>
      <button type="button" onClick={onClose}
        style={{ border: "none", background: "transparent", cursor: "pointer", fontWeight: 700, fontSize: 16 }}>
        ×
      </button>
    </div>
  );
}

// ── main component ─────────────────────────────────────────────────────────────
export default function GalleryUpload({ user }) {

  // ── data state ──────────────────────────────────────────────────────────────
  const [galleries,    setGalleries]    = useState([]);
  

  

 

  // ── upload form fields ──────────────────────────────────────────────────────
  const [title,       setTitle]       = useState("");
  const [description, setDescription] = useState("");
  const [galleryId,   setGalleryId]   = useState("");
  const [categoryId,  setCategoryId]  = useState("");
  const [subcategoryId, setSubcategoryId] = useState("");
  const [uploadCategories,   setUploadCategories]   = useState([]);
  const [uploadSubcategories,setUploadSubcategories]= useState([]);
  const [files,   setFiles]   = useState([]);
  const [loading, setLoading] = useState(false);

  // ── toast ───────────────────────────────────────────────────────────────────
  const [toast, setToast] = useState({ message: "", type: "" });
  const showToast = (message, type = "success") => setToast({ message, type });
  const clearToast = () => setToast({ message: "", type: "" });

  // ── auth helper ─────────────────────────────────────────────────────────────
  async function getAuthHeaders() {
    const u = auth.currentUser;
    if (!u) throw new Error("Please sign in first");
    const token = await u.getIdToken(true);
    return { "X-Firebase-Authorization": `Bearer ${token}` };
  }

  // ── loaders ─────────────────────────────────────────────────────────────────
 const loadGalleries = async () => {
  try {
    const headers = await getAuthHeaders();

    const res = await fetch(
      `${API_BASE}/api/gallery/galleries`,
      { headers }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(
        data?.message ||
        data?.error ||
        `Failed to load galleries (${res.status})`
      );
    }

    console.log(
      "GALLERIES RESPONSE",
      data
    );

    console.log(
      "GALLERIES COUNT",
      data?.galleries?.length || 0
    );

    setGalleries(
      Array.isArray(data?.galleries)
        ? data.galleries
        : []
    );

  } catch (e) {
    console.error(
      "LOAD GALLERIES ERROR",
      e
    );
  }
};

  const loadCategoriesFor = async (
  gId,
  setter
) => {
  if (!gId) {
    setter([]);
    return;
  }

  try {
    const headers = await getAuthHeaders();

    const res = await fetch(
      `${API_BASE}/api/gallery/categories/${gId}`,
      { headers }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(
        data?.message ||
        data?.error ||
        `Failed to load categories (${res.status})`
      );
    }

    console.log(
      "CATEGORIES RESPONSE",
      gId,
      data
    );

    console.log(
      "CATEGORIES COUNT",
      data?.categories?.length || 0
    );

    setter(
      Array.isArray(data?.categories)
        ? data.categories
        : []
    );

  } catch (e) {
    console.error(
      "LOAD CATEGORIES ERROR",
      e
    );
  }
};

  const loadSubcategoriesFor = async (
  cId,
  setter
) => {
  if (!cId) {
    setter([]);
    return;
  }

  try {
    const headers = await getAuthHeaders();

    const res = await fetch(
      `${API_BASE}/api/gallery/subcategories/${cId}`,
      { headers }
    );

    const data = await res.json();

    if (!res.ok) {
      throw new Error(
        data?.message ||
        data?.error ||
        `Failed to load subcategories (${res.status})`
      );
    }

    console.log(
      "SUBCATEGORIES RESPONSE",
      cId,
      data
    );

    console.log(
      "SUBCATEGORIES COUNT",
      data?.subcategories?.length || 0
    );

    setter(
      Array.isArray(data?.subcategories)
        ? data.subcategories
        : []
    );

  } catch (e) {
    console.error(
      "LOAD SUBCATEGORIES ERROR",
      e
    );
  }
};

  // ── init ────────────────────────────────────────────────────────────────────
 useEffect(() => {

  if (!user?.uid) {
    return;
  }

  loadGalleries();

}, [user]);




  // upload form cascade
  useEffect(() => { loadCategoriesFor(galleryId, setUploadCategories); setCategoryId(""); setSubcategoryId(""); }, [galleryId]);
  useEffect(() => { loadSubcategoriesFor(categoryId, setUploadSubcategories); setSubcategoryId(""); }, [categoryId]);

  

  // ── UPLOAD ──────────────────────────────────────────────────────────────────
  const upload = async () => {
    if (!title.trim())    { alert("Please enter title"); return; }
    if (!galleryId)       { alert("Please select gallery"); return; }
    if (!categoryId)      { alert("Please select category"); return; }
    if (!subcategoryId)   { alert("Please select subcategory"); return; }
    if (!files.length)    { alert("Please select images"); return; }
    if (files.length > 10){ alert("Maximum 10 images allowed"); return; }
    for (const f of files) if (f.size > 10 * 1024 * 1024) { alert(`${f.name} exceeds 10 MB`); return; }

    try {
      setLoading(true); clearToast();
      const headers = await getAuthHeaders();
      const gallery    = galleries.find(g => g.id === galleryId);
      const category   = uploadCategories.find(c => c.id === categoryId);
      const subcategory= uploadSubcategories.find(s => s.id === subcategoryId);

      const fd = new FormData();
      fd.append("uid",          user.uid);
      fd.append("userName",     user.displayName || "");
      fd.append("userEmail",    user.email || "");
      fd.append("title",        title.trim());
      fd.append("description",  description.trim());
      fd.append("galleryId",    galleryId);
      fd.append("galleryName",  gallery?.name || "");
      fd.append("categoryId",   categoryId);
      fd.append("categoryName", category?.name || "");
      fd.append("subcategoryId",   subcategoryId);
      fd.append("subcategoryName", subcategory?.name || "");
      files.forEach(f => fd.append("images", f));

      const res  = await fetch(`${API_BASE}/api/gallery/upload`, { method: "POST", headers, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || data?.error || "Upload failed");

      showToast("Upload submitted successfully and is awaiting admin approval.");
      // only reset content — keep hierarchy for bulk uploads
      setTitle(""); setDescription(""); setFiles([]);
    } catch (e) { showToast(e.message, "error"); }
    finally { setLoading(false); }
  };

  const removeFile = (i) => setFiles(prev => prev.filter((_, idx) => idx !== i));

  const isUploadDisabled = loading || !galleryId || !categoryId || !subcategoryId || !title.trim() || !files.length;

  // ── UI ───────────────────────────────────────────────────────────────────────
  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", color: "#111827", maxWidth: 680, margin: "0 auto" }}>

      <Toast message={toast.message} type={toast.type} onClose={clearToast} />

     
     

      {/* ── 4. Upload Form ────────────────────────────────────────────────── */}
      <h2 style={{ margin: "0 0 4px", fontSize: 18, fontWeight: 700 }}>Upload Educational Content</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0, marginBottom: 16 }}>
        Upload drawings, worksheets, charts, coloring pages and educational activities.
      </p>

      <Field label="Title *">
        <input value={title} onChange={e => setTitle(e.target.value)}
          placeholder="Enter title" style={inputStyle} />
      </Field>

      <Field label="Description">
        <textarea value={description} onChange={e => setDescription(e.target.value)}
          placeholder="Enter description" rows={3}
          style={{ ...inputStyle, resize: "vertical" }} />
      </Field>

      {galleries.length === 0 && (
        <div style={{ background: "#fef3c7", padding: 12, borderRadius: 8, marginBottom: 12, fontSize: 13 }}>
          No galleries found. Create one above first.
        </div>
      )}

      {/* hierarchy selectors side by side */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 12 }}>
        <Field label="Gallery *">
          <select value={galleryId} onChange={e => setGalleryId(e.target.value)} style={selectStyle}>
            <option value="">Select</option>
            {galleries.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
          </select>
        </Field>
        <Field label="Category *">
          <select value={categoryId} onChange={e => setCategoryId(e.target.value)}
            disabled={!galleryId} style={{ ...selectStyle, opacity: !galleryId ? 0.5 : 1 }}>
            <option value="">Select</option>
            {uploadCategories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </Field>
        <Field label="Subcategory *">
          <select value={subcategoryId} onChange={e => setSubcategoryId(e.target.value)}
            disabled={!categoryId} style={{ ...selectStyle, opacity: !categoryId ? 0.5 : 1 }}>
            <option value="">Select</option>
            {uploadSubcategories.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </Field>
      </div>

      <Field label={`Images * ${files.length ? `— ${files.length} selected` : ""}`}>
        <input type="file" multiple accept="image/*"
          onChange={e => setFiles(Array.from(e.target.files || []))}
          style={{ fontSize: 14 }} />
        {files.length > 0 && (
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 4 }}>
            {files.length} image{files.length !== 1 ? "s" : ""} selected
            {files.length > 10 && <span style={{ color: "#dc2626", marginLeft: 6 }}>— max 10 allowed</span>}
          </div>
        )}
      </Field>

      {/* preview grid */}
      {files.length > 0 && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 10, marginBottom: 16 }}>
          {files.map((file, i) => (
            <div key={i} style={{ position: "relative" }}>
              <img src={URL.createObjectURL(file)} alt=""
                style={{ width: "100%", height: 120, objectFit: "cover", borderRadius: 8, display: "block" }} />
              <button type="button" onClick={() => removeFile(i)} style={{
                position: "absolute", top: 5, right: 5, border: "none",
                borderRadius: "50%", width: 24, height: 24, cursor: "pointer",
                background: "rgba(0,0,0,.55)", color: "#fff", fontSize: 13,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>✕</button>
            </div>
          ))}
        </div>
      )}

      <Btn onClick={upload} disabled={isUploadDisabled} loading={loading} variant="success">
        Submit For Approval
      </Btn>

    </div>
  );
}
